import React, { useState } from "react";

const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const formData = {
        access_key: "b1296ae0-5187-4e29-ac13-0045c18cd2c6",
        email: email,
      };

      // You might want to replace this with your actual API endpoint
      const response = await fetch("your-api-endpoint", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setShowSuccess(true);
        setEmail("");
        setTimeout(() => setShowSuccess(false), 3000);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  return (
    <section className="newsletter_section">
      <div className="container">
        <div className="newsletter_box">
          <div
            className="section_title"
            data-aos="fade-in"
            data-aos-duration="1500"
            data-aos-delay="100"
          >
            <h2>Subscribe newsletter</h2>
            <p>Be the first to receive all latest post in your inbox</p>
          </div>

          <form
            id="newsletter-form"
            onSubmit={handleSubmit}
            data-aos="fade-in"
            data-aos-duration="1500"
            data-aos-delay="100"
          >
            <div className="form-group">
              <input
                type="email"
                name="email"
                className="form-control"
                placeholder="Enter your email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="form-group">
              <button type="submit" className="btn">
                SUBMIT
              </button>
            </div>
          </form>

          {/* Success message popup */}
          <div
            id="success-popup"
            className="popup"
            style={{ display: showSuccess ? "block" : "none" }}
          >
            <div className="popup-content">
              <p style={{ fontSize: "20px" }}>Form submitted successfully.</p>
              <button
                onClick={() => setShowSuccess(false)}
                className="btn btn-primary btn-lg"
              >
                OK
              </button>
            </div>
          </div>
          <div
            id="popup-overlay"
            style={{ display: showSuccess ? "block" : "none" }}
          ></div>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;
